import { useTranslation } from 'react-i18next'

import { stopPropagation } from '../../../../utils/events'
import {
  QA_NAME_PHOTO_DELETE,
  QA_NAME_PHOTO_OPEN,
  QA_NAME_PHOTO_RETRY,
  QA_NAME_PHOTO_SET_COVER,
} from '../RentalPortalPhotoGallery.constants'
import {
  getPhotoCoverTooltip,
  getPhotoDeleteTooltip,
  getPhotoRetryTooltip,
} from '../RentalPortalPhotoGallery.utils'

import { useRentalPortalPhotoGalleryTileOverlayActions } from './RentalPortalPhotoGalleryTileOverlayActions.hooks'
import { RentalPortalPhotoGalleryTileOverlayActionsButton } from './RentalPortalPhotoGalleryTileOverlayActionsButton'

import * as styles from './RentalPortalPhotoGalleryTileOverlayActions.module.css'

import DeleteIcon from '../../../../icons/delete.svg'
import ExpandIcon from '../../../../icons/expand.svg'
import RefreshIcon from '../../../../icons/refresh.svg'
import StarIcon from '../../../../icons/star.svg'
import StarFilledIcon from '../../../../icons/star-filled.svg'

function RentalPortalPhotoGalleryTileOverlayActions({
  disabled,
  disabledReason,
  isCover,
  onOpen,
  onRemove,
  onRetry,
  onSetCover,
}) {
  const { t } = useTranslation()

  const { handleOpen, handleRemove, handleRetry, handleSetCover } =
    useRentalPortalPhotoGalleryTileOverlayActions({
      onOpen,
      onRemove,
      onRetry,
      onSetCover,
    })

  return (
    <div
      className={styles.RentalPortalPhotoGalleryTileOverlayActions}
      onPointerDown={stopPropagation}
    >
      {onRetry ? (
        <RentalPortalPhotoGalleryTileOverlayActionsButton
          Icon={RefreshIcon}
          disabled={disabled}
          qaName={QA_NAME_PHOTO_RETRY}
          tooltip={getPhotoRetryTooltip({ disabled, disabledReason, t })}
          onClick={handleRetry}
        />
      ) : null}
      {onOpen ? (
        <RentalPortalPhotoGalleryTileOverlayActionsButton
          Icon={ExpandIcon}
          qaName={QA_NAME_PHOTO_OPEN}
          tooltip={t('RentalPortal.ListingPhotoOpenKey')}
          onClick={handleOpen}
        />
      ) : null}
      {onSetCover ? (
        <RentalPortalPhotoGalleryTileOverlayActionsButton
          Icon={isCover ? StarFilledIcon : StarIcon}
          disabled={disabled || isCover}
          isGrey={false}
          qaName={QA_NAME_PHOTO_SET_COVER}
          tooltip={getPhotoCoverTooltip({
            disabled,
            disabledReason,
            isCover,
            t,
          })}
          onClick={handleSetCover}
        />
      ) : null}
      {onRemove ? (
        <RentalPortalPhotoGalleryTileOverlayActionsButton
          Icon={DeleteIcon}
          disabled={disabled}
          qaName={QA_NAME_PHOTO_DELETE}
          tooltip={getPhotoDeleteTooltip({ disabled, disabledReason, t })}
          onClick={handleRemove}
        />
      ) : null}
    </div>
  )
}

export default RentalPortalPhotoGalleryTileOverlayActions
